export default {
  artisans: [],
}
